import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    defaultMessage: 'Define Fill Time SLA',
    id: 'ZGl2AA',
    description: 'title describing that this modal defines the service level agreement',
  },
  description: {
    defaultMessage:
      "Fill Time SLA is the commitment you set to pack and label orders within a specific time frame. Set your Fill Time SLA (in hours) so you can measure your actual warehouse performance against your company's SLA standards.",
    id: 'msc5WA',
    description: 'description of what fill time sla means',
  },
  notShownToCustomerNotice: {
    defaultMessage: '<i>This setting is for internal use only and is not communicated to your customers.</i>',
    id: '7yaldL',
    description: 'Notice that tells the user that SLA is for internal purposes only',
  },
  slaLabel: {
    defaultMessage: 'Fill Time SLA (hours)',
    id: 'cFk5m5',
    description: 'the label for input (unit of time)',
  },
  slaHelperText: {
    defaultMessage: 'Maximum SLA allowed is 96 hours.',
    id: 'YwGO54',
    description: 'helper text explaining the max sla time allowed in hours',
  },
  saveButton: {
    defaultMessage: 'Save',
    id: 'dcDpOn',
    description: 'button that saves the selection',
  },
});
